/**
 * all actions for the reports
 *
 * Created by Paul on 04/07/19
 */

import C from '../constants'

export const requestReport = objectVal => {
    return {
        type: C.REQUEST_REPORT,
        payload: objectVal
    }
}

export const downloadReport = objectVal => {
	return {
        type: C.DOWNLOAD_REPORT,
        payload: objectVal
    }
}


// WEBPACK FOOTER //
// ./src/actions/reportActions.js